module.exports = __webpack_public_path__ + "img/KEX_logo_RGB-White.4486418c.png";